import React from "react"
import { IconWrapper, IconPathAnimated } from "shared/Styles/Icons"

const IVLogo = ({ color, width, height }) => (
  <IconWrapper
    id="Warstwa_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 296.7 67.3"
    xmlSpace="preserve"
  >
    <g>
      <IconPathAnimated color={color} d="M9.6,0.8v29.9H0V0.8H9.6z" />
      <IconPathAnimated color={color}
        d="M45.1,12.4v18.4h-9v-17c0-3.7-2.3-5.4-5.2-5.4c-3.3,0-5.6,1.9-5.6,6.2v16.3h-9V0.8h9v2.8C27,1.4,30,0,34,0
      C40,0,45.1,4.3,45.1,12.4z"
      />
      <IconPathAnimated color={color} d="M62.6,0.8h6.2v8.6h-6.2V20c0,2.6,2.2,2.8,6.2,2.6v8.1C57.1,31.9,53.7,28.4,53.7,20V9.4h-4.8V0.8h4.8" />
      <IconPathAnimated color={color}
        d="M88.5,23.6c2.5,0,4.5-1,5.7-2.3l7.2,4.1c-2.9,4.1-7.4,6.2-13,6.2c-10.2,0-16.6-6.9-16.6-15.8C71.8,6.9,78.3,0,87.7,0
      c8.7,0,15.2,6.8,15.2,15.8c0,1.3-0.1,2.5-0.4,3.6H81.3C82.4,22.5,85.2,23.6,88.5,23.6z M94,12.7C93,9.2,90.3,8,87.6,8
      c-3.4,0-5.7,1.7-6.5,4.7H94z"
      />
      <IconPathAnimated color={color} d="M125.9,0.2v10.2c-3.7-0.6-9,0.9-9,6.8v13.5h-9V0.8h9v5.3C118.1,2.2,122.1,0.2,125.9,0.2z" />
      <IconPathAnimated color={color}
        d="M159.8,0.8v29.9h-9v-2.8c-2,2.3-4.9,3.6-8.9,3.6c-7.8,0-14.3-6.9-14.3-15.8C127.7,6.9,134.1,0,142,0c4,0,6.9,1.4,8.9,3.6
      V0.8H159.8z M150.9,15.8c0-4.5-3-7.3-7.1-7.3c-4.1,0-7.1,2.8-7.1,7.3c0,4.5,3,7.3,7.1,7.3C147.9,23.1,150.9,20.3,150.9,15.8z"
      />
      <IconPathAnimated color={color}
        d="M164.9,15.8c0-8.9,6.8-15.8,15.8-15.8c5.8,0,10.9,3,13.5,7.7l-7.8,4.5c-1-2.1-3.2-3.3-5.8-3.3c-3.9,0-6.8,2.8-6.8,6.9
      s2.9,6.9,6.8,6.9c2.6,0,4.8-1.3,5.8-3.3l7.8,4.5c-2.6,4.7-7.7,7.7-13.5,7.7C171.7,31.6,164.9,24.7,164.9,15.8z"
      />
      <IconPathAnimated color={color} d="M215.4,0.8v8.6h-6.2V20c0,2.6,2.2,2.8,6.2,2.6v8.1c-11.7,1.2-15.1-2.3-15.1-10.7V9.4h-4.8V0.8" />
      <IconPathAnimated color={color} d="M220.5,0.8h9v29.9h-9V0.8z" />
      <IconPathAnimated color={color} d="M265,0.8l-11.1,29.9h-10.2L232.7,0.8h9.9l6.2,18.9l6.2-18.9H265z" />
      <IconPathAnimated color={color}
        d="M282.3,23.6c2.5,0,4.5-1,5.7-2.3l7.2,4.1c-2.9,4.1-7.4,6.2-13,6.2c-10.2,0-16.6-6.9-16.6-15.8c0-8.9,6.5-15.8,15.9-15.8
      c8.7,0,15.2,6.8,15.2,15.8c0,1.3-0.1,2.5-0.4,3.6h-21.2C276.2,22.5,279,23.6,282.3,23.6z M287.8,12.7c-1-3.5-3.6-4.7-6.3-4.7
      c-3.4,0-5.7,1.7-6.5,4.7H287.8z"
      />
    </g>
    <g>
      <IconPathAnimated color={color} d="M32.3,36.6L21.2,66.5H11.1L0,36.6h9.9l6.2,18.9l6.2-18.9H32.3z" />
      <IconPathAnimated color={color} d="M35.6,36.6h9v29.9h-9V36.6z" />
      <IconPathAnimated color={color}
        d="M75,57.5c0,6.9-6,9.8-12.4,9.8c-6,0-10.5-2.3-12.9-7.1l7.8-4.4c0.8,2.3,2.5,3.5,5.1,3.5c2.2,0,3.2-0.7,3.2-1.9
      c0-3.3-14.7-1.6-14.7-11.9c0-6.5,5.5-9.8,11.7-9.8c4.8,0,9.1,2.2,11.7,6.4l-7.7,4.1c-0.8-1.6-2-2.6-4-2.6c-1.6,0-2.5,0.6-2.5,1.7
      C60.3,48.7,75,46.5,75,57.5z"
      />
      <IconPathAnimated color={color} d="M79.5,36.6h9v29.9h-9V36.6z" />
      <IconPathAnimated color={color}
        d="M93.5,51.5c0-8.9,7.1-15.8,15.8-15.8c8.8,0,15.8,6.9,15.8,15.8c0,8.9-7.1,15.8-15.8,15.8C100.6,67.3,93.5,60.4,93.5,51.5z
       M116.3,51.5c0-4.2-3-7.1-6.9-7.1c-3.9,0-6.9,2.8-6.9,7.1s3,7.1,6.9,7.1C113.3,58.6,116.3,55.8,116.3,51.5z"
      />
      <IconPathAnimated color={color}
        d="M160,48.1v18.4h-9v-17c0-3.7-2.3-5.4-5.2-5.4c-3.3,0-5.6,1.9-5.6,6.2v16.3h-9V36.6h9v2.8c1.6-2.2,4.6-3.6,8.5-3.6
      C154.8,35.8,160,40.1,160,48.1z"
      />
    </g>
    <IconPathAnimated color={color}
      d="M181.1,53.2l-3-3c-2.3-2.3-6.1-2.3-8.5,0l-3,3c-2.3,2.3-2.3,6.1,0,8.5l3,3c1.2,1.2,2.7,1.7,4.2,1.7
  c1.5,0,3.1-0.6,4.2-1.7l3-3C183.4,59.3,183.4,55.5,181.1,53.2z M178.2,58.8l-3,3c-0.8,0.8-2,0.8-2.8,0l-3-3c-0.8-0.8-0.8-2,0-2.8
  l3-3c0.4-0.4,0.9-0.6,1.4-0.6c0.5,0,1,0.2,1.4,0.6l3,3C179,56.8,179,58,178.2,58.8z"
    />
  </IconWrapper>
)

export { IVLogo }
